const heroProfile = {
	el: {
		container: document.querySelector('.js-hero-profile')
	},

	fxGetProfile () {
		const params = window.location?.search

		if(params.includes('profile')) {
			const profile = params.includes('&') ? params.split('&')[0].split('=')[1] : params.split('=')[1]
			return Number(profile)
		}
	},

	fxRenderProfileData () {
		const profiles = this.el.container.dataset.profiles,
			profilesArray = new Array(... profiles.split('&')),
			lastProfileArray = profilesArray.slice(-1),
			lastProfile = lastProfileArray[0],
			lastProfileID = Number(lastProfile.split(';')[0].split('=')[1]),
			defaultProfile = profilesArray[0],
			heroSubtitle = this.el.container.querySelector('.hero-video__subtitle')

		if(lastProfileID < this.fxGetProfile() || !window.location.search.includes('profile') || this.fxGetProfile() === 0) {
			const [profID, subtitle] = defaultProfile.split(';')
			heroSubtitle.textContent = subtitle.split('=')[1]
		} else {
			for (const profile of profilesArray) {
				const [profID, subtitle] = profile.split(';')
				
				if(Number(profID.split('=')[1]) === this.fxGetProfile()) {
					heroSubtitle.textContent = subtitle.split('=')[1]
				}
			}
		}
	},

	events () {
		this.fxRenderProfileData()
	},

	init () {
		if (!this.el.container) return
		this.events()
	}
}

heroProfile.init()